import { calculateProgress } from '../utils/courseUtils'; // Move calculateProgress to a utils file
import { LessonItem } from './LessonItem'; // Add this import

interface Lesson {
    id: string;
    title: string;
    completed: boolean;
    videoUrl: string;
}

interface Course {
    id: string;
    title: string;
    lessons: Lesson[];
}

interface CourseTOCProps {
    course: Course;
    currentLessonIndex: number;
    onSelectLesson: (index: number) => void;
}

export function CourseTOC({ course, currentLessonIndex, onSelectLesson }: CourseTOCProps) {
    const progress = calculateProgress(course.lessons);
    const firstUncompletedIndex = course.lessons.findIndex(l => !l.completed);
    const activeLessonForLocking = firstUncompletedIndex === -1 ? course.lessons.length - 1 : firstUncompletedIndex;

    return (
        <aside className="w-full">
            <div className="sticky top-6">
                <div className="bg-white p-4 rounded-lg shadow border border-slate-200 max-h-[calc(100vh-8rem)] flex flex-col">
                    <h3 className="text-lg font-semibold text-foreground mb-2 truncate">{course.title}</h3>
                    <div className="mb-4">
                        <div className="flex justify-between text-sm text-muted mb-1">
                            <span>Overall Progress</span>
                            <span>{progress}%</span>
                        </div>
                        <div className="w-full bg-slate-200 rounded-full h-2.5">
                            <div
                                className="bg-primary-600 h-2.5 rounded-full transition-all duration-300"
                                style={{ width: `${progress}%` }}
                            ></div>
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto course-toc pr-2">
                        <ul className="space-y-1">
                            {course.lessons.map((lesson, index) => (
                                <LessonItem
                                    key={lesson.id}
                                    lesson={lesson}
                                    index={index}
                                    isActive={index === currentLessonIndex}
                                    isLocked={index > activeLessonForLocking}
                                    onSelectLesson={onSelectLesson}
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </aside>
    );
}